export default __webpack_public_path__ + "static/media/B149.326f3134.png";